import { EXTRA_OFFSET_SIZE, ITEM_SIZE, PADDING_SIZE } from '../constants';

export const getOffsetForIndex = (index: number, itemCount: number, height: number): number => {
  const size = Math.round(height - PADDING_SIZE);
  const itemSize = ITEM_SIZE;
  const lastItemOffset = Math.max(0, itemCount * itemSize - size);

  return Math.min(lastItemOffset, index * itemSize - EXTRA_OFFSET_SIZE);
};
